/** Default My Vendors / within-list ordering — vendor name A→Z. */
export function compareVendorNamesAscending(a, b) {
  return String(a?.name || "").localeCompare(String(b?.name || ""), undefined, {
    sensitivity: "base",
  });
}

export function sortVendorsByNameAscending(vendors = []) {
  return [...vendors].sort(compareVendorNamesAscending);
}

export function getVendorNameAscendingSortOrder(vendors = []) {
  return sortVendorsByNameAscending(vendors)
    .map((vendor) => String(vendor.id))
    .filter(Boolean);
}
